// extracted by css-extract-rspack-plugin
module.exports =  {"astheme":"Imsx0","nshow":"p_2LO","icon_share":"Uxo2I","shareicon":"aNZL2","active":"pFrl6","gnews_top":"MaOYb","buttonPreferredSourcesWrapper":"__WNZ"};